//src/pages/admin/dashbaord/tabs/transactions/CustomerTransactions.jsx

import React, { useState } from "react";
import { getTransactionsByUserAccountNumber } from "../../../../../services/api";
import TransactionTable from "../../../../../components/transactions/TransactionTable";
import TransactionSummary from "../../../../../components/transactions/TransactionSummary";

const CustomerTransactions = () => {
  const [accountNumber, setAccountNumber] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState({ totalCredit: 0, totalDebit: 0 });

  const handleSearch = async () => {
    try {
      const { data } = await getTransactionsByUserAccountNumber(accountNumber);

      if (data.success) {
        const txns = data.data.map((txn) => ({
          id: txn._id, // added as a fix of row id issue
          customer: txn.userId?.name,
          phone: txn.userId?.phone,
          accountNumber: txn.accountNumber,
          type: txn.type,
          amount: txn.amount,
          doneBy: txn.performedBy?.id?.name,
          date: txn.createdAt,
          balance: txn.newBalance,
        }));

        setTransactions(txns);

        // Summary
        const totalCredit = txns
          .filter((t) => t.type === "credit")
          .reduce((sum, t) => sum + t.amount, 0);

        const totalDebit = txns
          .filter((t) => t.type === "debit")
          .reduce((sum, t) => sum + t.amount, 0);

        setSummary({ totalCredit, totalDebit });
      }
    } catch (error) {
      alert("Error fetching transactions");
    }
  };

  return (
    <div>
      <h3>Customer Transactions</h3>

      {/* Search */}
      <input
        type="text"
        placeholder="Enter User Account Number"
        value={accountNumber}
        onChange={(e) => setAccountNumber(e.target.value)}
        className="form-control mb-2"
      />

      <button className="btn btn-primary mb-3" onClick={handleSearch}>
        Search
      </button>

      {/* Summary */}
      <TransactionSummary summary={summary} />

      {/* Table */}
      <TransactionTable transactions={transactions} />
    </div>
  );
};

export default CustomerTransactions;
